import moment from 'moment';

exports.checkUsername = (value, validator, $field) => {
  let check = true;

  if (value === '') {
    return true;
  }

  // Check string length
  if (value.length < 6 || value.length > 30) {
    return {
      valid: false,

      message: $field.attr('data-fv-stringlength-message')
    };
  }

  // Check chars
  const pattern = /^[a-zA-Z0-9_.]+$/i;

  if (!pattern.test(value)) {
    return {
      valid: false,

      message: $field.attr('data-fv-regexp-message')
    };
  }

  const xhr = new XMLHttpRequest();

  xhr.open('POST', '/ajax.php', false);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.send(`id=300&mode=nickCheck&adduser=${value}`);

  check = JSON.parse(xhr.responseText).free;

  if (!check) {
    return {
      valid: false,
      message: $field.attr('data-fv-callback-message')
    };
  }

  return check;
};

exports.checkEmail = (value, validator, $field) => {
  let check = false;

  if (value === '') {
    return {
      valid: false,

      message: 'das ist eine probe'
    };
  }

  // Check email
  const pattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i; //eslint-disable-line

  if (!pattern.test(value)) {
    return {
      valid: false,

      message: $field.attr('data-fv-emailaddress-message')
    };
  }

  const xhr = new XMLHttpRequest();

  xhr.open('POST', '/ajax.php', false);
  xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
  xhr.send(`id=300&mode=mailCheck&adduser=${value}`);

  check =
    JSON.parse(xhr.responseText).free || JSON.parse(xhr.responseText).mxcheck;

  return check;
};

exports.checkDate = (value, validator, $field) => {
  const $html = $field.parents('html');
  const langAttr = $html[0].getAttribute('lang');
  const lang = langAttr.split('-', 1);

  if (value === '') {
    return true;
  }

  switch (lang[0]) {
    case 'de':
      return moment(value, 'DD.MM.YYYY', true).isValid();
    case 'fr':
      return moment(value, 'DD/MM/YYYY', true).isValid();
    case 'it':
      return moment(value, 'DD/MM/YYYY', true).isValid();
    case 'hu':
      return moment(value, 'YYYY.MM.DD.', true).isValid();
    default:
      return moment(value, 'MM/DD/YYYY', true).isValid();
  }
};

exports.checkZipCode = (value, validator, $field) => {
  const dfd = new $.Deferred();

  const countrySelected = $field
    .parents('form')
    .find('[name=Country]')
    .val();

  // Check string length
  if (value.length < 2) {
    dfd.resolve({
      valid: false,
      message: $field.attr('data-fv-stringlength-message')
    });

    return dfd.promise();
  }

  return $.ajax({
    contentType: 'application/x-www-form-urlencoded',
    data: {
      id: 305,
      mode: 'plzCheck',
      adduser: `${value}`,
      userstatus: `${countrySelected}`
    },
    dataType: 'json',
    method: 'POST',
    url: '/ajax.php'
  }).then(data => ({
    valid: data.known,
    message: $field.attr('data-fv-callback-message')
  }));
};

exports.subject = (value, validator, $field) => {
  const premium = $field.attr('data-fv-premium-message');
  const membership = $field.attr('data-fv-membership-message');
  const selectedSubject = $field.parents('html').find('[name=subject]')
    .selectedIndex;

  let message;

  if (value === '') {
    return true;
  }

  if (selectedSubject === 2 || selectedSubject === 4) {
    if (selectedSubject === 2) {
      message = premium;
    } else {
      message = membership;
    }
  }

  return {
    valid: false,

    message
  };
};



// WEBPACK FOOTER //
// ./src/main/javascripts/lib/validators.js